import React from "react";

export const RoadmapSection = () => {
  const roadmap = [
    { quarter: "Q2", year: "2025", text: "Token Launch & Presale" },
    { quarter: "Q3", year: "2025", text: "Staking Platform Live" },
    { quarter: "Q4", year: "2025", text: "NFT Launch & Community Events" },
    { quarter: "Q1", year: "2026", text: "Learning Portal for Kids" },
    { quarter: "Q2", year: "2026", text: "Mobile App & Global Partnerships" },
  ];

  return (
    <div className="relative w-full h-auto overflow-x-hidden"  id="roadmap">
      {/* Background */}
      <div className="w-full min-h-[891px] bg-[url(https://c.animaapp.com/mcbkuyz6ov2q95/img/hq7sfsf2sfsdf0-pica.png)] bg-cover bg-center">

        {/* Title + Description */}
        <div className="flex flex-col items-center justify-center gap-8 max-w-[1342px] mx-auto px-4 pt-20">
          <div className="flex flex-col md:flex-row justify-between w-full items-center gap-6 md:gap-0">
            <h2 className="font-fredoka text-[36px] md:text-[64px] font-bold bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] bg-clip-text text-transparent font-[Baloo_2] whitespace-nowrap">
              Roadmap
            </h2>
            <div className="md:w-[661px] border-l-4 border-transparent pl-6 border-transparent [border-image:linear-gradient(10deg,rgba(48,40,67,1)_16%,rgba(255,193,227,1)_25%,rgba(195,177,255,1)_41%,rgba(174,226,255,1)_58%,rgba(46,39,67,1)_78%)_1] flex items-center border-image-[linear-gradient(10deg,rgba(48,40,67,1)_16%,rgba(255,193,227,1)_25%,rgba(195,177,255,1)_41%,rgba(174,226,255,1)_58%,rgba(46,39,67,1)_78%)] border-image-slice-[1]">
              <p className="text-neutral-100 text-[16px] md:text-[22px] leading-8">
                BABYU has 1 billion tokens, with fair distribution for presale,
                staking, community, and long-term growth — all designed to support
                a fun, secure, and thriving ecosystem.
              </p>
            </div>
          </div>
        </div>

        {/* ✅ Mobile + Tablet View (stacked) */}
        <div className="w-full px-6 py-10 flex flex-col items-center gap-6 lg:hidden">
          {roadmap.map((item, index) => (
            <div key={index} className="flex flex-col items-center w-full max-w-[400px] gap-2">
              <div className="text-lg font-bold text-transparent bg-gradient-to-br from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] bg-clip-text font-[Baloo_2]">
                {item.quarter}
              </div>
              <div className="w-full rounded-xl p-4 bg-[#3a335066] backdrop-blur-md frame-505">
                <h3 className="text-white text-[18px] font-semibold text-center">{item.year}</h3>
                <p className="text-neutral-100 text-[16px] mt-1 text-center">{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* ✅ Desktop Timeline Cards (unchanged, only on lg and above) */}
        <div className="hidden lg:block mt-20 w-full px-4">
          <div className="flex md:flex-row md:justify-center items-center gap-8 md:gap-6">
            {roadmap.map((item, index) => (
              <div key={index} className="flex flex-col items-center w-full max-w-[270px]">
                <img
                  className="relative w-px h-[102.14px] object-cover"
                  alt="Line"
                  src="https://c.animaapp.com/mcbkuyz6ov2q95/img/line-32.svg"
                />
                <div className="text-2xl md:text-4xl font-bold bg-gradient-to-br from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF] bg-clip-text text-transparent text-center font-[Baloo_2]">
                  {item.quarter}
                </div>
                <img
                  src="https://c.animaapp.com/mcbkuyz6ov2q95/img/line-32.svg"
                  className="w-px h-[100px] object-cover"
                  alt=""
                />
                <div className="frame-505 w-full sm:w-[48%] md:w-[270px] md:h-[180px] bg-[#3a335066] rounded-xl p-4 text-center">
                  <div className="text-xl font-semibold text-white">{item.year}</div>
                  <div className="text-[18px] text-neutral-100 leading-7">
                    {item.text}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ✅ Desktop glow line and dots (unchanged, only on lg and above) */}
        <div className="hidden lg:block relative w-full max-w-[1344px] mx-auto mt-[-120px] mb-16 z-10">
          <div className="relative h-6">
            <img
              className="absolute w-[1343px] h-0.5 top-[-302px] left-0"
              alt="Line"
              src="https://c.animaapp.com/mcbkuyz6ov2q95/img/line-32-2.svg"
            />
            <div className="w-[864px] justify-between absolute top-0 left-[242px] flex items-center">
              {[...Array(roadmap.length)].map((_, i) => (
                <div key={i} className="relative w-6 h-6 bg-[#ffb6ef] rounded-xl blur-[10.8px]">
                  <div className="h-6 bg-[#ffb6ef] rounded-xl blur-[31.7px]">
                    <div className="relative w-3.5 h-3.5 top-[5px] left-[5px] rounded-[7.2px] bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom space */}
        <div className="h-16"></div>
      </div>
    </div>
  );
};
